<template>
  <div class="homecontainer"
       :style="' background-color:'+String(backgoundcolor)">
    <GoodTitle :goodinfo="goodinfo"
               :fontcolor="fontcolor" />
    <img :src="imgsrc"
         alt="iphonese">
  </div>
</template>

<script>
import GoodTitle from '@/components/comcomponents/GoodTitle'

export default {
  name: '',
  components: {
    GoodTitle
  },
  props: ['goodinfo', 'fontcolor', 'imgsrc', 'backgoundcolor']
}
</script>

<style lang="less" scoped>
.homecontainer {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  min-height: 500px;
  max-height: 1080x;
  font-size: 1em;
  img {
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/subcomponents/GoodBriefInfo.vue